import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupCashflowItem } from "src/components/Shared/NewForms/NFLookupCashflowItem";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";

const ExpenseCashsDetailPayments = () => {
  const { t } = useTranslation();
  return (
    <>
      <NFormTable fieldArray={"payments"}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupBaseDocuments title={t("ArApDocument")} fieldName="arApDocument" />
        <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={200} />
        <NFLookupCashflowItem title={t("cashFlowItemId")} fieldName="cashFlowItemId" width={200} />
        <NFIntInput title={t("Amount")} fieldName="amount" />
        <NFIntInput title={t("CurrencyRate")} fieldName="currencyRate" />
        <NFIntInput title={t("CurrencyQuantity")} fieldName="currencyQuantity" width={150} />
        <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
      </NFormTable>
    </>
  );
};

export default ExpenseCashsDetailPayments;
